import { useState } from 'react';

import {
    academyPlaceholderHeaderData,
    academyPlaceholderTableData,
    AcademyPlaceholderTableRow,
} from './AcademyPlaceholder.settings';

import { DefaultTable, SearchField } from '@speeki/global-ui-components';

import { PlaceholderLayout } from '@components/templates/PlaceholderLayout';

import {
    ContentHeader,
    ContentHeaderText,
    ContentWrapper,
} from '@pages/StaticPlaceholder.styled';

import { SearchFieldWrapper } from './AcademyPlaceholder.styled';

export const AcademyPlaceholder = () => {
    const [searchValue, setSearchValue] = useState('');

    return (
        <PlaceholderLayout
            headingOptions={{
                icon: 'SvgAcademy',
                title: 'Speeki Academy',
            }}
        >
            <ContentWrapper gap={'48px'}>
                <ContentHeader>
                    <ContentHeaderText>
                        A centralised hub to register and access additional
                        learning offered by Speeki.
                    </ContentHeaderText>
                    <SearchFieldWrapper>
                        <SearchField
                            onChange={setSearchValue}
                            onReset={() => {
                                setSearchValue('');
                            }}
                            onSearch={() => {}}
                            placeholder={'Search...'}
                            testId="HJVo8BG"
                            value={searchValue}
                        />
                    </SearchFieldWrapper>
                </ContentHeader>
                <div>
                    <DefaultTable<AcademyPlaceholderTableRow>
                        columns={academyPlaceholderHeaderData}
                        data={academyPlaceholderTableData}
                        pagination={{
                            options: {
                                defaultPageSize: 6,
                                totalCount: academyPlaceholderTableData.length,
                            },
                        }}
                        tableRow={{
                            onRowClick: () => {},
                            showRightArrow: true,
                            testId: 'dr4P7Bs',
                        }}
                        tableState={{
                            hiddenColumns: ['id'],
                        }}
                        testId="a8METOG"
                    />
                </div>
            </ContentWrapper>
        </PlaceholderLayout>
    );
};
